module.exports = __webpack_public_path__ + "@/assets/img/mp4.dde8b5da.svg";